var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 275,
    viewBox: "0 0 275 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M201.79 0H73.3333C26.5222 0 0 26.5222 0 73.3333V201.667C0 248.478 26.5222 275 73.3333 275H201.79C248.6 275 275 248.478 275 201.667V73.3333C275 26.5222 248.6 0 201.79 0Z",
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5668_36667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.42 114.266C174.181 114.266 173.943 114.246 173.707 114.205C172.584 114.018 171.581 113.392 170.918 112.466C170.256 111.539 169.989 110.388 170.175 109.264L174.472 83.4828C174.639 82.478 175.158 81.5653 175.935 80.9073C176.713 80.2494 177.699 79.8891 178.717 79.8906H204.499C205.638 79.8906 206.731 80.3433 207.537 81.1492C208.343 81.955 208.795 83.0479 208.795 84.1875C208.795 85.3271 208.343 86.42 207.537 87.2259C206.731 88.0317 205.638 88.4844 204.499 88.4844H182.361L178.657 110.673C178.49 111.677 177.973 112.588 177.197 113.246C176.421 113.904 175.438 114.265 174.42 114.266Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.67 107.073C207.268 106.632 206.778 106.279 206.232 106.038C205.686 105.797 205.096 105.672 204.499 105.672H144.343C143.744 105.669 143.152 105.792 142.604 106.032C142.056 106.271 141.563 106.623 141.159 107.064C140.754 107.505 140.446 108.025 140.255 108.592C140.063 109.159 139.992 109.76 140.046 110.356L148.64 204.887C148.736 205.958 149.231 206.954 150.027 207.678C150.823 208.402 151.861 208.801 152.936 208.797H195.905C196.981 208.801 198.019 208.402 198.815 207.678C199.61 206.954 200.105 205.958 200.202 204.887L208.796 110.356C208.847 109.76 208.773 109.161 208.579 108.595C208.385 108.03 208.076 107.512 207.67 107.073Z",
    fill: "#DADADA",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M161.53 183.016H84.1865C83.0469 183.016 81.954 183.468 81.1482 184.274C80.3424 185.08 79.8896 186.173 79.8896 187.312C79.8896 193.011 82.1532 198.475 86.1823 202.504C90.2114 206.533 95.676 208.797 101.374 208.797H144.343C150.041 208.797 155.505 206.533 159.535 202.504C163.564 198.475 165.827 193.011 165.827 187.312C165.827 186.173 165.374 185.08 164.569 184.274C163.763 183.468 162.67 183.016 161.53 183.016Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M161.53 165.828H84.1865C83.0469 165.828 81.954 165.375 81.1482 164.57C80.3424 163.764 79.8896 162.671 79.8896 161.531C79.8896 155.833 82.1532 150.369 86.1823 146.34C90.2114 142.31 95.676 140.047 101.374 140.047H144.343C150.041 140.047 155.505 142.31 159.535 146.34C163.564 150.369 165.827 155.833 165.827 161.531C165.827 162.671 165.374 163.764 164.569 164.57C163.763 165.375 162.67 165.828 161.53 165.828Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.827 165.828H79.8896C75.1435 165.828 71.2959 169.676 71.2959 174.422C71.2959 179.168 75.1435 183.016 79.8896 183.016H165.827C170.573 183.016 174.421 179.168 174.421 174.422C174.421 169.676 170.573 165.828 165.827 165.828Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5668_36667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.5,
    height: 137.5,
    fill: "white",
    transform: "translate(71.2959 71.2969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/EmptyState.ba962ac7264d79442aff20dcb4b1a9d1.svg";
export { ForwardRef as ReactComponent };